export default __webpack_public_path__ + "92abf134a00371dce3221711c140f722.png";